export const REQUIRED_ONBOARDING = 'required-onboarding';
export const PROMOTIONS = 'promotions';
export const PRODUCT = 'product';
export const OWNERSHIP = 'ownership';
export const RETAIL = 'retail';
export const CONTACTS = 'contacts';
export const MARKETING_CONTACTS_RENEWAL = 'marketing-contacts-on-mc-renewal';
export const MARKETING_CONTACTS_SWITCH = 'marketing-contacts-on-mc-switch';
export const PHONE_NUMBERS = 'phone-numbers';
export const SETTINGS = 'settings';
export const PUBLIC_META = 'public-meta';
export const PRODUCT_INVENTORY = 'product-inventory';